import '../../../css/web/UserModalRenew.css'
import useTheme from '../layoutscommon/DarkModeStorage'
import React, {useEffect, useRef, useState} from "react";
import '../../../css/web/BtorageGlobalModal.css'
import {useTranslation} from "react-i18next";
import commonClose from "../../../assets/img/commonClose.png";
import creditCard from "../../../assets/img/blueCard.png";
import popupYellowCard from "../../../assets/img/popupYellowCard.png";
import popupPinkCard from "../../../assets/img/popupPinkCard.png";
import popupPurpleCard from "../../../assets/img/popupPurpleCard.png";
import popupClose from "../../../assets/img/popupClose.png";
import popupCardAdd from "../../../assets/img/popupCardAdd.png";
import popupCheckBox from "../../../assets/img/popupCheckBox.png";
import popupNoCheckBox from "../../../assets/img/popupNoCheckBox.png";
import visa from "../../../assets/img/visa.png";
import amex from "../../../assets/img/amex.png";
import master from "../../../assets/img/master.png";
import MsgCheckModal from "./MsgCheckModal";
import axios from "axios";
import {refreshAccessToken} from "../../../services/axiosInstance";
import {Swiper, SwiperSlide} from "swiper/react";
import {EffectCoverflow} from "swiper/modules";
import BtorageGlobalPasswordModal from "./BtorageGlobalPasswordModal";
import jcb from "../../../assets/img/jcb.png";
import CardRefundPolicy from "./CardRefundPolicy";
import {serverLog} from "../../../utils/ServerLog";
import {initPayAttempt, notifyCancel, PAY_USAGE} from "../../../services/PayGuard";

function BtorageGlobalModal({
                                    btorageGlobalPopupSt,
                                    closeBtorageGlobalPopup,
                                    currency,
                                    mbNum,
                                    finalPayExpense,
                                    lastForPrice,
                                    afterOrderProcess,
                                    usageType, // [결제누락 개선] 결제원장 용도 (주문서작성/주문서수정/예치금충전)
                                }) {
    const {t} = useTranslation();
    const [theme] = useTheme();
    const [payErrorMsg, setPayErrorMsg] = useState(false);
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const platformType = window.navigator.userAgent.includes('Mobi') ? '2' : '1';
    const modalWidth = platformType === '2' ? 350 : 400;

    const [easyPassword, setEasyPassword] = useState('');
    const [easyPasswordError, setEasyPasswordError] = useState(false);

    const [inputPayBtLoading, setInputPayBtLoading] = useState(false);
    const [inputPayBtDisabled, setInputPayBtDisabled] = useState(false);

    const [btoragePayData, setBtoragePayData] = useState([]);
    const selectedBtoragePayInfo = () => {
        axios({
            method: 'get',
            url: '/btoragePay/selectedBtoragePayInfo',
            headers: {
                Authorization: LCAT || SSAT,
            },
            params: {
                mbNum: mbNum,
                type: '0'
            },
        })
            .then((response) => {
                const data = response.data
                setBtoragePayData(data);
            })
            .catch((error) => {
                console.log("카드조회오류 : ", error)
            });
    };

    const [payerMail, setPayerMail] = useState("");
    const findEmail = () => {
        axios({
            method: 'get',
            url: '/member/findEmail',
            params: {
                mbNum: mbNum,
            },
        })
            .then((response) => {
                setPayerMail(response.data);
            })
            .catch((error) => {
                console.log("이메일 조회오류 : ", error)
            });
    };

    useEffect(() => {
        if (mbNum) {
            selectedBtoragePayInfo();
            findEmail();
        }
    }, [mbNum])


    // 10자리 숫자생성기
    const generatePayNum = () => {
        const today = new Date();
        const year = today.getFullYear().toString().slice(2); // 연도 마지막 2자리
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // 월 (2자리)
        const day = today.getDate().toString().padStart(2, '0'); // 일 (2자리)

        const dateString = `${year}${month}${day}`; // yyMMdd 형식
        const randomLong = Math.floor(Math.random() * 10_000); // 4자리 랜덤 숫자
        const randomNumber = randomLong.toString().padStart(10, '0');
        return dateString + randomNumber;
    }

    const [popupBlock, setPopupBlock] = useState(false);
    const closePopupBlock = () => {
        setPopupBlock(false);
    }

    const payWinRef = useRef(null);
    const pollingWorkerRef = useRef(null);
    const popupCheckIntervalRef = useRef(null);

    // ══════════════════════════════════════════════════════════════════════════════
    // [결제누락 개선]
    //  1) payNumRef : 실제 결제식별번호(payNum)를 보관하여 afterOrderProcess 로 전달한다.
    //     (기존에는 "btorageGlobalOrder" 라는 상수문자열을 넘겨 PG 결제건과 주문서를 연결할 수 없었다)
    //  2) 유예폴링 : 결제팝업이 닫혀도 즉시 폴링을 종료하지 않고 아래 시간동안 결제성공 여부를 계속 확인한다.
    //     (기존에는 팝업 닫힘 즉시 terminate() 하여, 결제완료 직후 팝업을 바로 닫으면 결제성공을
    //      감지하지 못해 주문서가 저장되지 않는 누락이 발생했다)
    // ══════════════════════════════════════════════════════════════════════════════
    const payNumRef = useRef(null);
    const graceTimeoutRef = useRef(null);
    const PAY_POLLING_GRACE_MS = 90000; // 팝업 닫힘 후 결제확인 유예시간 (90초)

    /** 폴링/타이머 일괄 정리 */
    const clearPayWatchers = () => {
        if (popupCheckIntervalRef.current) {
            clearInterval(popupCheckIntervalRef.current);
            popupCheckIntervalRef.current = null;
        }
        if (graceTimeoutRef.current) {
            clearTimeout(graceTimeoutRef.current);
            graceTimeoutRef.current = null;
        }
        if (pollingWorkerRef.current) {
            pollingWorkerRef.current.terminate();
            pollingWorkerRef.current = null;
        }
    };

    // 컴포넌트 언마운트 시 폴링 워커가 남지 않도록 정리
    useEffect(() => {
        return () => clearPayWatchers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmitInputPay = async () => {
        setInputPayBtDisabled(true);
        setInputPayBtLoading(true);

        if (!validation()) {
            setInputPayBtDisabled(false);
            setInputPayBtLoading(false);
            return;
        }
        if (!cardPolicyAgree) {
            setCardPolicyAgreeError(true);
            setInputPayBtDisabled(false);
            setInputPayBtLoading(false);
            return;
        }

        try {
            const btoragePayNum = generatePayNum();
            payNumRef.current = btoragePayNum;

            // [결제누락 개선] 결제팝업을 열기 전에 결제원장을 선기록한다.
            //  이후 페이레터가 서버로 직접 보내는 noti 에서 서버가 이 원장을 PAID 로 확정하므로,
            //  주문서 저장이 실패하더라도 '결제됨/주문없음' 누락건을 반드시 탐지할 수 있다.
            await initPayAttempt({
                payNum: btoragePayNum,
                payWay: 'PM06',
                usageType: usageType || PAY_USAGE.ORDER,
                amount: finalPayExpense,
                forAmount: lastForPrice,
                forCurrency: currency,
            });

            const isMobile = platformType === '2';
            const popupWidth = 800;
            const popupHeight = 500;

            // PC 사이즈 설정
            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
            const windowWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
            const left = dualScreenLeft + (windowWidth - popupWidth) / 2;
            const top = dualScreenTop + (windowHeight - popupHeight) / 2;

            const windowFeatures = isMobile ? '' : `width=${popupWidth},height=${popupHeight},left=${left},top=${top},resizable=yes,scrollbars=yes`;
            // 브라우저별 팝업정책으로 미리 빈창 열기
            let payWin = window.open('', 'PayletterPay', windowFeatures);
            payWinRef.current = payWin;

            // recurringType=Y -> notiurl로 콜백
            const notiurl = `https://btorage.com/api/btoragePay/saveOsInputPayInfo?mbNum=${mbNum}&easyPassword=${easyPassword}&payNum=${btoragePayNum}&cardPgInfo=PLCreditCard&type=0`;
            const returnurl = `https://btorage.com/api/btoragePay/PaymentLoading`;

            // 엔화만 소숫점 2자리 수 제거
            const convertToPrice =
                currency === "JPY"
                    ? String(lastForPrice).includes('.')
                        ? String(lastForPrice).split('.')[0]  // 소수점 앞부분만
                        : lastForPrice  // 이미 정수라면 그대로
                    : lastForPrice;

            const res = await axios.post('/btoragePay/osPayOpenWindow', {
                currency: currency,
                payNum: btoragePayNum,
                amount: convertToPrice,
                payerid: payerMail,
                payeremail: payerMail,
                returnurl: returnurl,
                notiurl: notiurl,
                pginfo: selectedPgInfo,
                recurringtype: "Y",
                servicename: "Btorage"
            }, );

            console.log("payWin : ", payWin)
            console.log("응답값 : ", res?.data)

            // 팝업 && 데이터 보장
            if (payWin && res?.data) {
                console.log("Pop-up open")
                // ✅ polling 시작 (Web Worker 방식)
                startPollingWithWorker(mbNum, btoragePayNum, LCAT || SSAT);
                payWin.location.href = platformType === '2' ? res.data.mobile_url : res.data.online_url;
            } else {
                setPopupBlock(true);
                setInputPayBtDisabled(false);
                setInputPayBtLoading(false);
                return;
            }

            // 팝업 닫힘 감지
            popupCheckIntervalRef.current = setInterval(() => {
                if (payWinRef.current && payWinRef.current.closed) {
                    setInputPayBtDisabled(false);
                    setInputPayBtLoading(false);
                    clearInterval(popupCheckIntervalRef.current);
                    popupCheckIntervalRef.current = null;

                    // [결제누락 개선] 팝업이 닫혀도 폴링을 즉시 종료하지 않고 유예시간동안 결제성공 여부를 계속 확인한다.
                    if (pollingWorkerRef.current && !graceTimeoutRef.current) {
                        graceTimeoutRef.current = setTimeout(() => {
                            if (pollingWorkerRef.current) {
                                pollingWorkerRef.current.terminate();
                                pollingWorkerRef.current = null;
                                // 유예시간까지 결제확인이 안 되면 사용자가 결제를 취소한 것으로 간주
                                notifyCancel({
                                    payNum: payNumRef.current,
                                    failReason: 'Payment popup closed and not confirmed within grace period',
                                });
                            }
                            graceTimeoutRef.current = null;
                        }, PAY_POLLING_GRACE_MS);
                    }
                }
            }, 500);

        } catch (err) {
            console.log("최종결제실패 : ", err)
            setPayErrorMsg(true);
            setInputPayBtDisabled(false);
            setInputPayBtLoading(false);
        }
    };

    // ✅ polling 전용 함수 (Web Worker 생성)
    /** 폴링 중 토큰만료로 재발급을 시도한 마지막 시각 (2초 폴링마다 두드리지 않도록 조절) */
    const lastTokenRenewRef = useRef(0);

    const startPollingWithWorker = (mbNum, payNum, token) => {
        serverLog("웹 워커 Start @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@")
        if (pollingWorkerRef.current) {
            pollingWorkerRef.current.terminate();
        }

        const workerCode = () => {
            let timer = null;
            let authToken = null;

            // eslint-disable-next-line no-restricted-globals
            self.onmessage = async function (e) {
                /*
                 * [토큰교체 메시지] 메인스레드가 갱신된 액세스토큰을 보내온 경우.
                 *  토큰만 바꿔 끼우고 즉시 끝낸다. 여기서 빠져나가지 않으면 아래
                 *  setInterval 이 하나 더 생겨 폴링이 중복 실행된다.
                 */
                if (e.data && e.data.type === 'TOKEN') {
                    if (e.data.token) authToken = e.data.token;
                    return;
                }

                const { mbNum, payNum, token, url } = e.data;
                authToken = token;

                const poll = async () => {
                    try {
                        const res = await fetch(`${url}?mbNum=${mbNum}&payNum=${payNum}`, {
                            method: 'POST',
                            headers: {
                                Authorization: authToken,
                            },
                        });
                        /*
                         * [중요] 401 은 '액세스토큰이 만료됐다' 는 뜻이다.
                         *  워커는 시작할 때 받은 토큰을 그대로 들고 있으므로, 여기서
                         *  그냥 넘기면 같은 토큰으로 영원히 401 만 받으며 결제완료를
                         *  끝까지 감지하지 못한다 (= 결제누락).
                         *  메인스레드에 새 토큰을 요청하고, 폴링은 멈추지 않는다.
                         */
                        if (res.status === 401) {
                            // eslint-disable-next-line no-restricted-globals
                            self.postMessage({ status: 'TOKEN_EXPIRED' });
                            return;
                        }
                        if (!res.ok) {
                            throw new Error(`웹 워커 poll.res 응답에러 : ${res.status}`);
                        }
                        const data = await res.json();
                        if (data) {
                            clearInterval(timer);
                            // eslint-disable-next-line no-restricted-globals
                            self.postMessage({ status: 'COMPLETED' });
                        }
                    } catch (err) {
                        console.error('Polling error:', err);
                        // eslint-disable-next-line no-restricted-globals
                        self.postMessage({ status: 'ERROR', error: err.message });
                        // 통신 오류 시에도 무시하고 polling 지속
                    }
                };

                // [결제누락 개선] 폴링 주기 5초 -> 2초 (결제성공 감지 지연으로 인한 누락 최소화)
                await poll();
                timer = setInterval(poll, 2000);
            };
        };

        const blob = new Blob(['(' + workerCode.toString() + ')()'], { type: 'application/javascript' });
        const worker = new Worker(URL.createObjectURL(blob));
        pollingWorkerRef.current = worker;

        const fullUrl = new URL('/api/btoragePay/selectedPayNum', window.location.origin).href;
        worker.postMessage({ mbNum, payNum, token, url: fullUrl });

        worker.onmessage = function (e) {
            if (e.data.status === 'COMPLETED') {
                setInputPayBtDisabled(false);
                setInputPayBtLoading(false);
                if (payWinRef.current && !payWinRef.current.closed) {
                    payWinRef.current.close();
                }
                clearPayWatchers();
                // [결제누락 개선] 상수문자열이 아닌 실제 결제식별번호(payNum)를 전달하여 주문서에 저장되도록 한다.
                afterOrderProcess("COMPLETED", payNumRef.current || payNum, "btorageGlobal");
            } else if (e.data.status === 'TOKEN_EXPIRED') {
                /*
                 * 폴링 중 액세스토큰이 만료됐다. 조용히 갱신해서 워커에 새 토큰을 넘긴다.
                 *  갱신이 실패해도 폴링은 계속 돌고 있으므로, 30초에 한 번만 시도해
                 *  (폴링주기 2초마다 재발급을 두드리는 것을 막는다) 서버 부담을 피한다.
                 */
                const now = Date.now();
                if (now - lastTokenRenewRef.current >= 30000) {
                    lastTokenRenewRef.current = now;
                    refreshAccessToken().then((fresh) => {
                        if (fresh && pollingWorkerRef.current) {
                            pollingWorkerRef.current.postMessage({ type: 'TOKEN', token: fresh });
                        }
                    });
                }
            } else if (e.data.status === 'ERROR') {
                console.error('Error from polling worker:', e.data.error);
            }
        };
    };

    const easyPay = async () => {
        try {
            // 엔화만 소숫점 2자리 수 제거
            const convertToPrice =
                currency === "JPY"
                    ? String(lastForPrice).includes('.')
                        ? String(lastForPrice).split('.')[0]  // 소수점 앞부분만
                        : lastForPrice  // 이미 정수라면 그대로
                    : lastForPrice;

            const btoragePayNum = generatePayNum();
            payNumRef.current = btoragePayNum;

            // [결제누락 개선] 간편결제(2회차)도 동일하게 결제원장 선기록
            await initPayAttempt({
                payNum: btoragePayNum,
                payWay: 'PM06',
                usageType: usageType || PAY_USAGE.ORDER,
                amount: finalPayExpense,
                forAmount: lastForPrice,
                forCurrency: currency,
            });

            const response = await axios({
                method: 'post',
                url: '/btoragePay/easyOsPay',
                headers: {
                    Authorization: LCAT || SSAT,
                },
                data: {
                    seqNum: focusData.seqNum,
                    mbNum: mbNum,
                    payNum: btoragePayNum,
                    currency: currency,
                    amount: convertToPrice,
                    payerid: payerMail,
                    pginfo: focusData?.cardPgInfo,
                },
            });
            if (response.status === 200 && response.data) {
                const data = response.data;
                console.log("페이레터 간편결제 성공 시 : ", data)
                afterOrderProcess("COMPLETED", btoragePayNum, "btorageGlobal");
            } else {
                console.log("간편결제 실패: 응답 상태코드", response.status);
                setPayErrorMsg(true);
            }
        } catch (error) {
            console.log("간편결제 실패", error);
            setPayErrorMsg(true);
        }
    };

    const validation = () => {
        let isValue = true;
        if (!cardPolicyAgree) {
            setCardPolicyAgreeError(true);
            isValue = false
        }
        if (!easyPassword || easyPassword.length !== 6) {
            setEasyPasswordError(true);
            isValue = false;
        } else {
            setEasyPasswordError(false);
        }
        return isValue;
    }

    const closePayErrorMsg = () => {
        setPayErrorMsg(false);
    }

    // 카드환불규정
    const [cardPolicyAgree, setCardPolicyAgree] = useState(false);
    const [cardPolicyAgreeError, setCardPolicyAgreeError] = useState(false);
    const [isCardPoilicyPopup, setIsCardPoilicyPopup] = useState(false);
    const handleAgreeChange = () => {
        setCardPolicyAgree(prev => !prev);
    };
    const closeCardPolicyAgreeError = () => {
        setCardPolicyAgreeError(false);
    }
    const closeCardPolicyPopup = () => {
        setIsCardPoilicyPopup(false);
    }


    // 여기서부터 카드 UI
    // const [testBtoragePayData, setTestBtoragePayData] = useState([
    //     { seqNum: 0, payNum: "id1", name:"A User", easyPassword: "123258", lastCardNumber: "1234", type: '0', defaultCardFl: true },
    //     { seqNum: 1, payNum: "id2", name:"B User", easyPassword: "456258", lastCardNumber: "5678", type: '0', defaultCardFl: false },
    // ]);
    const [carouselData, setCarouselData] = useState([]);
    const [cardImages, setCardImages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [focusData, setFocusData] = useState(null);

    const carouselRef = useRef(null);
    const scrollViewRef = useRef(null);
    const [cardPasswordPopupShow, setCardPasswordPopupShow] = useState(false);

    const width = window.innerWidth; // 리액트 웹에서는 이렇게 가져옴

    useEffect(() => {
        const images = [popupYellowCard, popupPinkCard, popupPurpleCard];
        setCardImages(images);
    }, []);

    const [ready, setReady] = useState(false); // ✅ 스냅캐러셀은 잘되는데 스와이프만 렌더링 오류때문에 한 번 더 상태값 설정
    useEffect(() => {
        const data = [...btoragePayData]; // 항상 배열이므로 그대로 복사
        while (data.length < 3) {
            data.push({isAddCard: true});
        }
        setCarouselData(data);
        const defaultIndex = data.findIndex(item => item.defaultCardFl);
        const finalIndex = defaultIndex !== -1 ? defaultIndex : 0;

        setCurrentIndex(finalIndex);
        setFocusData(data[finalIndex]);
        setReady(true);
    }, [btoragePayData]);

    const handleDefaultCardChange = async () => {
        if (!focusData || focusData.isAddCard) return;

        try {
            await axios.post('/btoragePay/changeDefaultCard', {
                mbNum: focusData.mbNum,
                seqNum: focusData.seqNum
            }, {
                headers: {Authorization: LCAT || SSAT}
            });

            setBtoragePayData(prevData =>
                prevData.map(item => ({
                    ...item,
                    defaultCardFl: item.seqNum === focusData.seqNum
                }))
            );
        } catch (err) {
            console.error('Default 카드 설정 실패', err);
        }
    };

    const deleteCard = async () => {
        if (!focusData || focusData.isAddCard) return;

        try {
            await axios({
                method: 'post',
                url: '/btoragePay/deleteCard',
                headers: {Authorization: LCAT || SSAT},
                params: {
                    seqNum: focusData.seqNum,
                    payNum: focusData.payNum
                }
            }).then(() => {
                setBtoragePayData(prevData =>
                    prevData.filter(item => item.seqNum !== focusData.seqNum)
                );
            });
        } catch (err) {
            console.error('카드삭제실패', err);
        }
    };

    const closeCardPasswordPopup = () => {
        setTimeout(() => setCardPasswordPopupShow(false), 500);
    };

    const cardClick = (action) => {
        if (!cardPolicyAgree) {
            setCardPolicyAgreeError(true);
            return;
        }
        if (action === 'add') {
            const el = scrollViewRef.current;
            if (el) {
                el.scrollTo({
                    top: el.scrollHeight,
                    behavior: 'smooth'
                });
            }
        } else {
            setCardPasswordPopupShow(true);
        }
    };


    // 여기서부터 카드사별 pginfo 분류 라디오박스
    const CARD_TYPES = [
        {
            value: "PLCreditCardMpi",
            key: "VISA",
            logos: [visa, master, jcb]
        },
        {
            value: "PLCreditCard",
            key: "AMEX",
            logos: [amex]
        },
        // {
        //     value: "PLUnionPay",
        //     key: "UNION",
        //     logos: [unionPay]
        // }
    ];

    // Amex, UnionPay는 USD만 표시
    const shownCards = CARD_TYPES.filter(card =>
        card.key === "VISA" || currency === "USD"
    );

    const [selectedPgInfo, setSelectedPgInfo] = useState("PLCreditCardMpi");






    return (
        <div className="btorage-pay-modal-container md-scope" data-theme={theme}>
            <div className="btorage-pay-modal-frame" style={{width: `${modalWidth}px`}}>
                <div className="btorage-pay-modal-scroll-area p-r-10" ref={scrollViewRef}>
                    <div className="font-t-cont">
                        {/*헤더*/}
                        <div className="display-flex just-cont-fend m-b-20">
                            <img onClick={closeBtorageGlobalPopup} className="c-point wd-30 ht-30 m-a-opc-06"
                                 src={commonClose}
                                 alt="close"/>
                        </div>
                        {/*바디*/}
                        <div className="btorage-pay-modal-body-container">
                            <div className="btorage-pay-modal-header-container">
                                <div className="btorage-pay-modal-header-frame">
                                    <p className="btorage-pay-modal-header-text">{t(`modHeader10`)}</p>
                                </div>
                                <div>
                                    <img src={creditCard} className="wd-40 ht-40" alt="btoragePay"/>
                                </div>
                            </div>

                            <div className="btorage-pay-modal-price-container">
                                <div className="btorage-pay-modal-price-frame">
                                    <a className="btorage-pay-modal-price-text1">{t(`pcWon`)}</a>
                                    <a className="btorage-pay-modal-price-text2">{finalPayExpense && finalPayExpense.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                </div>
                                <div className="btorage-pay-modal-price-frame">
                                    <a className="btorage-pay-modal-price-text1">{t(`modExr`)}</a>
                                    <div>
                                        <a className="btorage-pay-modal-price-text2">{lastForPrice && lastForPrice}</a>
                                        <a className="m-l-3 font-s-12 btorage-pay-modal-price-text1">{currency && currency}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    {/*푸터*/}
                    <div className="font-t-cont">

                        {/*카드환불규정*/}
                        <div className="display-flex align-center">
                            <div className="wd-100pc display-flex align-center min-ht-30 m-t-10" style={{backgroundColor:"#FFF3F1", borderRadius:"6px", padding:"0 10px"}}>
                                <div className="display-flex align-center">
                                    <input
                                        id="cardPolicyAgree"
                                        type="checkbox"
                                        className="wd-15 ht-15 c-point"
                                        checked={cardPolicyAgree}
                                        onChange={handleAgreeChange}
                                    />
                                </div>
                                <div className="wd-100pc display-flex align-center justify-content-between"
                                     style={{padding: "0 10px"}}>
                                    <div className="border-rd6" style={{backgroundColor:"#FFF3F1"}}>
                                        <label className="font-s-13 c-point" htmlFor="cardPolicyAgree"><span style={{color: "#FF7962"}}>{t('bpmTx20')}</span>
                                        </label>
                                    </div>
                                    <div onClick={()=> setIsCardPoilicyPopup(true)}>
                                        <a className="font-s-12 c-point" style={{color: "#FF7962"}}>{t('bpmTx21')}</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="ht-50 display-flex align-items-end just-cont-center m-t-30">
                            <p className="font-s-14" style={{color: "#01579B"}}>( {t('bpmTx15')} )</p>
                        </div>

                        {/*스와이프*/}
                        <div className="wd-100pc ht-100pc user-center">
                            {ready && (
                                <Swiper
                                    ref={carouselRef}
                                    modules={[EffectCoverflow]}
                                    effect={'coverflow'}
                                    centeredSlides={true}
                                    slidesPerView={3}
                                    coverflowEffect={{
                                        rotate: 0,
                                        stretch: 0,
                                        depth: 100,
                                        modifier: 1.5,
                                        slideShadows: false,
                                    }}
                                    onSlideChange={(swiper) => {
                                        setCurrentIndex(swiper.realIndex);
                                        setFocusData(carouselData[swiper.realIndex]);
                                    }}
                                    initialSlide={currentIndex}
                                    style={{
                                        width: platformType === '2' ? "1200px" : width,
                                        padding: `0 ${width * 0.2}px`,
                                        overflow: 'visible',
                                    }}
                                >
                                    {carouselData.map((item, index) => (
                                        <SwiperSlide
                                            key={index} className="btorage-pay-modal-swipe-style">
                                            {item.isAddCard ? (
                                                <div className="wd-100pc ht-250 user-center"
                                                     style={{padding: "0 20px"}}>
                                                    <div onClick={() => cardClick('add')}
                                                         className="btorage-pay-modal-addcard-frame">
                                                        <img src={popupCardAdd} alt="Add Card" className="wd-60 ht-60"
                                                             style={{opacity: 0.1}}/>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="wd-100pc ht-250 position-relative user-center">
                                                    <div className="btorage-pay-modal-card-data-frame">
                                                        {item.defaultCardFl ? (
                                                            <img src={popupCheckBox} alt="Checked"
                                                                 className="wd-25 ht-25"
                                                                 style={{opacity: 0.6}}/>
                                                        ) : (
                                                            <div onClick={handleDefaultCardChange}
                                                                 className="display-flex align-center c-point">
                                                                <img src={popupNoCheckBox} alt="Unchecked"
                                                                     className="wd-25 ht-25" style={{opacity: 0.2}}/>
                                                                <span className="font-s-12 m-l-5"
                                                                      style={{color: '#555'}}>Default Card</span>
                                                            </div>
                                                        )}
                                                        <div onClick={deleteCard} className="c-point">
                                                            <img src={popupClose} alt="Close"
                                                                 className="wd-35 ht-35 object-fit-contain"/>
                                                        </div>
                                                    </div>

                                                    <div onClick={() => cardClick('pay')}
                                                         className="wd-100pc ht-100pc border-rd10 overflow-hidden c-point position-relative">
                                                        <img src={cardImages[index % 3]}
                                                             className="wd-100pc ht-95pc border-rd10" alt="Card"/>
                                                        {/* ✅ 아래 영역 없으면 카드이미지 쪼그라듬..? */}
                                                        <div className="btorage-pay-modal-card-text-layer">
                                                            {item?.lastCardNumber?.match(/.{1,4}/g)?.join('-')}
                                                        </div>
                                                    </div>

                                                    <div className="btorage-pay-modal-card-data-number-frame">
                                                        <span className="fw-bold font-s-15 font-c-fff">
                                                            {item?.lastCardNumber?.match(/.{1,4}/g)?.join('-')}
                                                        </span>
                                                    </div>

                                                    <div className="btorage-pay-modal-card-data-name-frame">
                                                        <span
                                                            className="fw-bold font-s-13 font-c-fff">{item?.name}</span>
                                                        {/*<span className="fw-bold font-s-13 font-c-fff">12/2026</span>*/}
                                                    </div>


                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            )}
                        </div>


                        {focusData && focusData.isAddCard &&
                            <div>

                                <div className="display-flex flex-row justify-content-between align-items-center">
                                    <a className="font-s-13">※ {t('bpmTx30')}</a>
                                    {/*<div className="user-center gap4">*/}
                                    {/*    <img alt="visa" className="wd-25 ht-20 gap3" src={visa}/>*/}
                                    {/*    <img alt="master" className="wd-25 ht-20 gap3" src={master}/>*/}
                                    {/*    <img alt="jcb" className="wd-25 ht-16 gap3" src={jcb}/>*/}
                                    {/*    {currency === "USD" &&*/}
                                    {/*        <div className="user-center">*/}
                                    {/*            <img alt="amex" className="wd-25 ht-18 gap3" src={amex}/>*/}
                                    {/*            <img alt="unionPay" className="wd-25 ht-20 gap3" src={unionPay}/>*/}
                                    {/*        </div>*/}
                                    {/*    }*/}
                                    {/*</div>*/}
                                </div>

                                {/*카드사선택*/}
                                <div className="display-flex gap10 wd-100pc just-cont-center align-items-center"
                                     style={{margin: "10px 0"}}>
                                    {shownCards.map(card => (
                                        <label
                                            key={card.key}
                                            className="border-rd6 display-flex align-items-center just-cont-center wd-100pc c-point"
                                            style={{
                                                border: "1px solid #EAEAEA",
                                                padding: "8px 16px",
                                            }}>
                                            <input
                                                type="radio"
                                                name="card-company"
                                                checked={selectedPgInfo === card.value}
                                                onChange={() => setSelectedPgInfo(card.value)}
                                                style={{display: "none"}}/>
                                            <span
                                                className="wd-16 ht-16 user-center m-r-5 position-relative bt-background-fff"
                                                style={{
                                                    border: selectedPgInfo === card.value ? "2px solid #FFBE48" : "2px solid #EAEAEA",
                                                    borderRadius: "50%",
                                                }}>
                                        {selectedPgInfo === card.value && (
                                            <span
                                                className="ht-8 position-absolute"
                                                style={{
                                                    width: 8,
                                                    borderRadius: "50%",
                                                    background: "#FFBE48",
                                                    left: 2,
                                                    top: 2
                                                }}>
                                            </span>
                                        )}
                                    </span>

                                            <span style={{display: "flex"}}>
                                        {card.logos.map((logo, idx) => (
                                            <img src={logo} key={idx} alt=""
                                                 className="wd-30 ht-20 object-fit-contain bt-background-fff"/>
                                        ))}
                                    </span>
                                        </label>
                                    ))}
                                </div>

                                {/*카드비밀번호인풋*/}
                                <div className="m-t-5">
                                    <div className="ReviewPgSearchFrame acc-icon">
                                        <div className="ReviewPgInputForm wd-97pc">
                                            <input className="ReviewInput user-input wd-100pc ht-100pc p-l-10 p-r-10"
                                                   style={{fontSize: "14px"}}
                                                   type="password"
                                                   autoComplete="new-password"
                                                   inputMode="numeric"     // 모바일 키보드 숫자 키패드 강제
                                                   pattern="\d*"           // 일부 브라우저 보조 (숫자만)
                                                   placeholder={t('bpmTx4')}
                                                   value={easyPassword}
                                                   onChange={(e) => setEasyPassword(e.target.value)}
                                                   maxLength={6}
                                            />
                                            <label className="JoinLabel font-s-14">{t('bpmTx4')}</label>
                                        </div>
                                    </div>
                                </div>

                                {easyPasswordError &&
                                    <div className="JoinErrorMsg m-t-10">
                                        <p className="JoinErrMsg">{t(`bpmTx29`)}</p>
                                    </div>}


                                <div className="user-center m-t-20 m-b-50">
                                    <style>
                                        {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                    </style>
                                    <button onClick={handleSubmitInputPay} disabled={inputPayBtDisabled}
                                            className="orderItemHandleBt wd-100pc ht-50 font-s-16 border-rd4 user-center">
                                        {inputPayBtLoading ? (
                                            <div className="spinner"></div>
                                        ) : (
                                            "Payment"
                                        )}
                                    </button>
                                </div>

                            </div>}

                    </div>

                </div>
            </div>


            {payErrorMsg ?
                <MsgCheckModal payErrorMsg={payErrorMsg} closePayErrorMsg={closePayErrorMsg}/>
                :
                    cardPolicyAgreeError ?
                        <MsgCheckModal cardPolicyAgreeError={cardPolicyAgreeError}
                                       closeCardPolicyAgreeError={closeCardPolicyAgreeError}/>
                        :
                        popupBlock ?
                            <MsgCheckModal popupBlock={popupBlock}
                                           closePopupBlock={closePopupBlock}/>
                            :
                        cardPasswordPopupShow ?
                            <BtorageGlobalPasswordModal focusData={focusData} easyPay={easyPay}
                                                        closeCardPasswordPopup={closeCardPasswordPopup}/>
                        :
                        isCardPoilicyPopup ?
                            <CardRefundPolicy closeCardPolicyPopup={closeCardPolicyPopup}/>
                :
                null
            }

        </div>
    )
}

export default BtorageGlobalModal
